import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowTooltipDirective } from './show-tooltip.directive';



@NgModule({
    declarations: [
        ShowTooltipDirective
    ],
    exports: [
        ShowTooltipDirective
    ],
    imports: [
        CommonModule
    ]
})
export class ShowTooltipModule { }
